"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_bill__pay__phone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "52a65716-0c20-4557-a4ef-109849742486",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "bill-pay-phone-mid"), /*#__PURE__*/React.createElement("g", {
    id: "38f8abea-9aac-4e9a-b631-d1c12ea18782",
    "data-name": "Business_ic_mid"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 84,
    y1: 158,
    x2: 108,
    y2: 158,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 18,
    width: 92,
    height: 156,
    rx: 14,
    ry: 14,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("line", {
    id: "51e373fe-a4eb-4f90-b3b5-13fd7084d66c",
    "data-name": "<Pfad>",
    x1: 126,
    y1: 108,
    x2: 90,
    y2: 108,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "da2e8833-e73a-4130-95e1-e330753897ac",
    "data-name": "<Pfad>",
    x1: 74,
    y1: 108,
    x2: 66,
    y2: 108,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "b5bfe90c-1e6a-445a-abc7-8a67b9797e6e",
    "data-name": "<Pfad>",
    x1: 126,
    y1: 60,
    x2: 90,
    y2: 60,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "19d5da2d-287b-49c7-9095-647bd8e4071b",
    "data-name": "<Pfad>",
    x1: 74,
    y1: 60,
    x2: 66,
    y2: 60,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "d0e26ff0-6cd8-4838-8e15-fc6b2c54019a",
    "data-name": "<Pfad>",
    x1: 126,
    y1: 84,
    x2: 90,
    y2: 84,
    fill: "none",
    stroke: "#6d6968",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "6f43ac19-3d0b-4098-8f19-1190860ce00b",
    "data-name": "<Pfad>",
    x1: 74,
    y1: 84,
    x2: 66,
    y2: 84,
    fill: "none",
    stroke: "#6d6968",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }));
}

var _default = ic_bill__pay__phone;
exports.default = _default;